import { render, staticRenderFns } from "./rolelist.vue?vue&type=template&id=ebb9e4b4"
import script from "./rolelist.vue?vue&type=script&lang=js"
export * from "./rolelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports